import axios from 'axios'

export default async function updateModelMember(path, Model, modelParams = {}) {
  const idParamName = `${Model.singularCamelFullName}Id`;
  const attributesParamName = `${Model.singularCamelFullName}Attributes`;
  const parameterizedPath = path.replace(
    `:${idParamName}`,
    modelParams[idParamName]
  );

  return axios
    .put(`${parameterizedPath}.json`, {
      [Model.singularCamelFullName]: modelParams[attributesParamName],
    })
    .then(({ data }) => {
      const instance = new Model(data[Model.singularCamelFullName])
      return { ...data, [Model.singularCamelFullName]: instance }
    });
}
